/**
 * Temporary file handoff between EmbedOnboarding and Dashboard.
 *
 * EmbedOnboarding collects files locally (no workspace yet, can't upload).
 * After provisioning, it stashes them here. Dashboard consumes them on mount
 * and uploads via the normal uppy flow.
 */
let pendingFiles: File[] = [];

export function setPendingFiles(files: File[]): void {
  pendingFiles = files;
}

export function consumePendingFiles(): File[] {
  const files = pendingFiles;
  pendingFiles = [];
  return files;
}
